module.exports = __webpack_public_path__ + "static/media/insights-analytics-suite.7a2d0eb5.jpg";